import { ClientLogsMessage, LogLevel } from "flavr-common";
import { serverConnection } from "./ServerConnectionService";
const SEND_INTERVAL = 60000;
const MAX_MESSAGE_LENGTH = 120;
const MAX_PENDING_LOGS = 50;
class LoggingService {
    constructor() {
        this.consoleErrorFunc = console.error;
        this.pendingLogMsgs = [];
    }
    log(msg) {
        console.log(msg);
    }
    error(msg) {
        this.consoleErrorFunc(msg);
        this.queueLog(msg, LogLevel.Error);
    }
    queueLog(msg, level) {
        if (typeof msg !== "string") {
            try {
                msg = JSON.stringify(msg);
            }
            catch (_a) {
                msg = msg.toString();
            }
        }
        if (msg.length > MAX_MESSAGE_LENGTH) {
            msg = msg.substring(MAX_MESSAGE_LENGTH);
        }
        this.pendingLogMsgs.push({
            msg,
            level,
            timestamp: Date.now()
        });
        if (this.pendingLogMsgs.length > MAX_PENDING_LOGS) {
            this.flushLogs();
        }
        else {
            this.startFlushTimer();
        }
    }
    flushLogs() {
        if (this.pendingLogMsgs.length === 0)
            return;
        if (this.flushTimer !== undefined) {
            window.clearTimeout(this.flushTimer);
        }
        serverConnection.queueBusMessage(new ClientLogsMessage(this.pendingLogMsgs));
        this.pendingLogMsgs = [];
        this.startFlushTimer();
    }
    startFlushTimer() {
        if (this.flushTimer !== undefined) {
            return;
        }
        this.flushTimer = window.setTimeout(() => {
            this.flushLogs();
        }, SEND_INTERVAL);
    }
}
export const loggingService = new LoggingService();
